import React, { useState, useEffect } from 'react';
import { Redirect, useLocation, useHistory } from 'react-router-dom';
import { Helmet } from 'react-helmet'
import { Link } from 'react-router-dom';
//import 'youtube-background';

import Sidebar from '../partials/Sidebar';
import Header from '../partials/Header';
import WelcomeBanner from '../partials/dashboard/WelcomeBanner';
import DashboardAvatars from '../partials/dashboard/DashboardAvatars';
import FilterButton from '../partials/actions/FilterButton';
import Datepicker from '../partials/actions/Datepicker';
import AlertModal from '../partials/AlertModal'
import PaginationNumeric from '../components/PaginationNumeric'

import DashboardCards from '../partials/dashboard/DashboardCards'
import LiveCampaignsContent from '../partials/dashboard/live-campaigns/LiveCampaignsContent'
import OptimalShedulingContent from '../partials/dashboard/optimal-scheduling/OptimalSchedulingContent'
import TrendingContent from '../partials/dashboard/trending-content/TrendingContent'

import { Auth, API, graphqlOperation } from 'aws-amplify';
import { getClientUser } from '../graphql/queries'
import { createClient, createClientUser, deleteClient, updateClient } from '../graphql/mutations'
import { Storage } from 'aws-amplify';

import DashboardHeatmapCard from '../partials/dashboard/DashboardHeatmapCard'
import DashboardCategoryCard from '../partials/dashboard/DashboardCategoryCard'
import DashboardCloudCard from '../partials/dashboard/DashboardCloudCard'


function Dashboard() {

  let history = useHistory();
  const location = useLocation()
  const search = location.search;
  const [sidebarOpen, setSidebarOpen] = useState(false);
  const [isAuthenticating, setIsAuthenticating] = useState(true);
  const [isAuthenticated, userHasAuthenticated] = useState(false);
  const [authSession, setAuthSession] = useState(null)
  const [alertModalState, setAlertModalState] = useState(null)
  const [contentState, setContentState] = useState('home')
  const [emulatorData, setEmulatorData] = useState({})
  const [ authToken, setAuthToken ] = useState(null)

  const [userDetails, setUserDetails] = useState({email: 'friend', client: { adminId: ''}})

  useEffect(() => {
    OnLoad();
  }, []);
  
  function updateContentState(newState){
    setContentState(newState)
  }

  function OnLoad() {

    Auth.currentSession().then(response => {
      setAuthSession(response)
      userHasAuthenticated(true);
      setIsAuthenticating(false);

      const status = new URLSearchParams(search).get('status');
      if(status==='synced')
        setAlertModalState({title: '🎉 Successfully Synced', message: 'EmPushy has synced your data ✔️. Check out the Integrations page ' +
            'for more insights and keep an eye on your notifications for updates 👀🔔'})
      else if(status==='oops')
        setAlertModalState({title: '🥺 Oops', message: 'Something went wrong. Please try again later or contact us to figure out what went wrong 🔨: hello@empushy.com'})
      else if(status==='disconnected')
        setAlertModalState({title: 'Successfully Disconnected 🥺', message: 'We have disconnected your integration and removed all associated data. Sad to see it go!'})

      fetchData(response.idToken.payload.sub, response.idToken.payload.email)

    }).catch( (error) => {
      history.push('/signin')
    });
  }

  async function fetchBatchEmulatorData(){
    const result = await Storage.get('emulator_analysis.json',
      { level: 'public', download: true, cacheControl: 'no-cache', contentType: 'application/json' })
    var data = await new Response(result.Body).json();
    setEmulatorData(data)
  }

  async function fetchData(sub, email) {
    const response = await API.graphql({ query: getClientUser, variables: { id: sub}})

    if(response.data.getClientUser!=null) {
      setUserDetails(response.data.getClientUser)
      fetchBatchEmulatorData()
    }
    else
      newClientUser(sub, email)

  }

  /*
  * Create a new client and client user
  * */
  async function newClientUser(sub, email) {
    /* create a client on free trial */

    const response = await Auth.currentUserCredentials()
    if('identityId' in response) {
      const identityId = response.identityId

      const clientDetails = {
        subscriptionId: '79aa7db0-d4e8-4b3a-94c4-0d9194e2bdc1',
        adminId: sub
      }
      var createClientResponse = await API.graphql({query: createClient, variables: {input: clientDetails}});
      if (createClientResponse.data.createClient != null) {
        /* create a client user */
        const clientUserDetails = {
          id: sub,
          clientId: createClientResponse.data.createClient.id,
          email: email,
          identityId: identityId
        }
        API.graphql({query: createClientUser, variables: {input: clientUserDetails}}).then(createUserResponse => {
          setUserDetails(createUserResponse.data.createClientUser)
          /*updateAppCues(sub)*/
        }).catch((createUserError) => {
          API.graphql({query: deleteClient, variables: {input: {id: createClientResponse.data.createClient.id}}})
          console.log('There was an error creating your account.')
        })

      }
    }
  }

  /*function updateAppCues(clientUserId){
    try {
      window.Appcues.identify(clientUserId);
      window.Appcues.show('5165b80f-fdc8-4a5a-8b50-887c6165ede9')
      fetchBatchEmulatorData()
    }catch (e) { console.log('could not update app cues') }
  }*/

  return !isAuthenticating && (
      <div className="flex h-screen overflow-hidden striped-background-pattern">
        {/* Page Title */}
        <Helmet>
          <title>EmPushy | Dashboard</title>
        </Helmet>

        {/* Sidebar */}
        <Sidebar sidebarOpen={sidebarOpen} setSidebarOpen={setSidebarOpen} userDetails={userDetails}/>

        {/* Content area */}
        <div className="relative flex flex-col flex-1 overflow-y-auto overflow-x-hidden">

          {/*  Site header */}
          <Header sidebarOpen={sidebarOpen} setSidebarOpen={setSidebarOpen} userDetails={userDetails}/>


          <main>

            {
              contentState=='home'?
              <div className="px-4 sm:px-6 lg:px-8 py-8 w-full max-w-9xl mx-auto">

                {/* Page header */}
                <div className="sm:flex sm:justify-between sm:items-center mb-5">

                  {/* Left: Title */}
                  <div className="mb-4 sm:mb-0">
                    <h1 className="text-2xl md:text-3xl text-slate-800 font-bold">Level up your Campaigns ✨</h1>
                  </div>

                  {/* Right: Actions */}
                  <div className="grid grid-flow-col sm:auto-cols-max justify-start sm:justify-end gap-2">

                    {/* Add meetup button */}
                    {/*<button className="btn bg-indigo-500 hover:bg-indigo-600 text-white">
                      <svg className="w-4 h-4 fill-current opacity-50 shrink-0" viewBox="0 0 16 16">
                        <path d="M15 7H9V1c0-.6-.4-1-1-1S7 .4 7 1v6H1c-.6 0-1 .4-1 1s.4 1 1 1h6v6c0 .6.4 1 1 1s1-.4 1-1V9h6c.6 0 1-.4 1-1s-.4-1-1-1z" />
                      </svg>
                      <span className="hidden xs:block ml-2">Feedback</span>
                    </button>*/}

                  </div>

                </div>

                {/* Filters */}
                <div className="mb-5">
                  <ul className="flex flex-wrap -m-1">
                    <li key="1" className="m-1">
                      <button className="inline-flex items-center justify-center text-sm font-medium leading-5 rounded-full px-3 py-1 border border-transparent shadow-sm bg-pink-500 text-white duration-150 ease-in-out">
                        View All
                      </button>
                    </li>
                    <li key="2" className="m-1">
                      <button className="inline-flex items-center justify-center text-sm font-medium leading-5 rounded-full px-3 py-1 border border-slate-200 hover:border-slate-300 shadow-sm bg-white text-slate-500 duration-150 ease-in-out">
                        Scheduling
                      </button>
                    </li>
                    <li key="3" className="m-1">
                      <button className="inline-flex items-center justify-center text-sm font-medium leading-5 rounded-full px-3 py-1 border border-slate-200 hover:border-slate-300 shadow-sm bg-white text-slate-500 duration-150 ease-in-out">
                        Content
                      </button>
                    </li>
                    <li key="4" className="m-1">
                      <button className="inline-flex items-center justify-center text-sm font-medium leading-5 rounded-full px-3 py-1 border border-slate-200 hover:border-slate-300 shadow-sm bg-white text-slate-500 duration-150 ease-in-out">
                        Automation
                      </button>
                    </li>
                    <li key="5" className="m-1">
                      <button className="inline-flex items-center justify-center text-sm font-medium leading-5 rounded-full px-3 py-1 border border-slate-200 hover:border-slate-300 shadow-sm bg-white text-slate-500 duration-150 ease-in-out">
                        Trends
                      </button>
                    </li>
                    <li key="6" className="m-1">
                      <button className="inline-flex items-center justify-center text-sm font-medium leading-5 rounded-full px-3 py-1 border border-slate-200 hover:border-slate-300 shadow-sm bg-white text-slate-500 duration-150 ease-in-out">
                        Templates
                      </button>
                    </li>
                  </ul>
                </div>

                {/* Content */}
                <DashboardCards updateContentState={updateContentState}/>


              </div>
              :contentState=='live-campaigns'?
              <LiveCampaignsContent updateContentState={updateContentState} setAlertModalState={setAlertModalState}
                                    authToken={authSession.idToken.jwtToken}/>
              :contentState=='optimal-scheduling'?
              <OptimalShedulingContent updateContentState={updateContentState} setAlertModalState={setAlertModalState}
                                       authToken={authSession.idToken.jwtToken}/>
              :contentState=='competitor-analysis'?
              <div className="px-4 sm:px-6 lg:px-8 py-8 w-full">
                {/* Page content */}
                <div className="max-w-5xl mx-auto flex flex-col lg:flex-row lg:space-x-8 xl:space-x-16">
                  {/* Content */}
                  <div>
                    <div className="mb-6">
                      <ul className="inline-flex flex-wrap text-sm font-medium">
                        <li key="1" className="flex items-center">
                          <div className="text-slate-500 hover:text-pink-500 cursor-pointer"
                               onClick={()=>updateContentState('home')}>Home</div>
                          <svg className="h-4 w-4 fill-current text-slate-400 mx-3" viewBox="0 0 16 16">
                            <path d="M6.6 13.4L5.2 12l4-4-4-4 1.4-1.4L12 8z" />
                          </svg>
                        </li>
                        <li key="2" className="flex items-center">
                          <a className="text-slate-500">Competitor Analysis</a>
                        </li>
                      </ul>
                    </div>
                    <header className="mb-4">
                      {/* Title */}
                      <h1 className="text-2xl md:text-3xl text-slate-800 font-bold mb-2">Competitor Anlaysis</h1>
                      <p>A lot of brands, apps and websites just don't have the resources to invest in marketing teams
                      for crafting notification or email campaigns. This makes it difficult to compete with bigger
                        brands who are powered by market insights. This guide can help you create campaigns
                      using your competitors insights, enabling you to create quality campaigns with less effort and cost.</p>
                    </header>

                    {/* Image */}
                    <div className="mb-10">
                      <DashboardCategoryCard data={emulatorData.recentEmojis} title={'Trending Emojis'} label={''}
                                             hint={'Emojis trending over the past 7 days in all markets'}/>
                    </div>
                  </div>

                  {/* Sidebar */}
                  <div className="space-y-4">
                    {/* 1st block */}
                    <div className="bg-white p-5 shadow-1 rounded-sm border border-slate-200 lg:w-72 xl:w-80">

                    </div>
                  </div>
                </div>
              </div>
              :contentState=='trending-content'?
              <TrendingContent updateContentState={updateContentState} setAlertModalState={setAlertModalState}
                                authToken={authSession.idToken.jwtToken}/>
              :''
            }

            <AlertModal params={alertModalState} toggleState={setAlertModalState}/>

          </main>
        </div>
      </div>
  );
}

export default Dashboard;